import React, {forwardRef} from 'react'
import SampleCompActor from './SampleCompActor'
import './SingleIdea.css'
import SampleCompZwrotAkcji from './SampleCompZwrotAkcji'
import SampleCompPytanie from './SampleCompPytanie'
// const Post = forwardRef(({name, description, message, photoUrl}, ref) => {

const SingleIdea = forwardRef(({i, name, type}, ref) => {
    return (
        <div ref={ref} className="single-idea">
            {type === "actor" && <SampleCompActor name={name} />}
            {type === "zwrotAkcji" && <SampleCompZwrotAkcji name={name}/>}
            {type === "pytanie" && <SampleCompPytanie name={name}/>}
        </div>
    )
})

export default SingleIdea
